'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalifyWrapper = function (_React$Component) {
  _inherits(ModalifyWrapper, _React$Component);

  function ModalifyWrapper(props) {
    _classCallCheck(this, ModalifyWrapper);

    var _this = _possibleConstructorReturn(this, (ModalifyWrapper.__proto__ || Object.getPrototypeOf(ModalifyWrapper)).call(this, props));

    _this.transitionLoading = false;
    _this.myRef = null;
    _this.setMyRef = function (element) {
      _this.myRef = element;
    };

    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }

  _createClass(ModalifyWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      document.addEventListener('keydown', this.handleKeydown);
      this.transitionLoading = true;
      // Mock the time it takes for the initial transition to finish (add a slight buffer).
      setTimeout(function () {
        _this2.transitionLoading = false;
      }, this.props.modalTransitionDuration + 50);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeydown);
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(event) {
      if (event.keyCode !== 27) {
        return;
      }
      if (this.props.closeOnEsc) {
        this.handleClose();
      }
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      var closeValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.closeReturn;

      if (!this.transitionLoading) {
        this.props.close(closeValue);
        this.props.afterClose(this.myRef);
      }
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside() {
      if (this.props.closeOnOverlayClick) {
        this.handleClose();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          ChildComponent = _props.ChildComponent,
          showCloseButton = _props.showCloseButton;

      return _react2.default.createElement(
        'div',
        { ref: this.setMyRef, className: 'modal-wrapper' },
        showCloseButton && _react2.default.createElement(
          'button',
          { className: 'close', onClick: function onClick() {
              return _this3.handleClose();
            } },
          _react2.default.createElement(
            'svg',
            { alt: 'Close', title: 'Close', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 36 36' },
            _react2.default.createElement('path', { d: 'M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z' })
          )
        ),
        _react2.default.createElement(ChildComponent, _extends({}, this.props, { close: this.handleClose }))
      );
    }
  }]);

  return ModalifyWrapper;
}(_react2.default.Component);

ModalifyWrapper.defaultProps = {
  close: function close() {
    return null;
  },
  afterClose: function afterClose() {
    return null;
  },
  closeReturn: false,
  closeOnEsc: true,
  modalTransitionDuration: 0,
  closeOnOverlayClick: true,
  showCloseButton: true
};

ModalifyWrapper.propTypes = {
  ChildComponent: _propTypes2.default.func.isRequired,
  close: _propTypes2.default.func,
  afterClose: _propTypes2.default.func,
  closeReturn: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
  closeOnEsc: _propTypes2.default.bool,
  modalTransitionDuration: _propTypes2.default.number,
  closeOnOverlayClick: _propTypes2.default.bool,
  showCloseButton: _propTypes2.default.bool
};

exports.default = ModalifyWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/ModalifyWrapper.js
// module id = 1027
// module chunks = 0